import { registerCollectionItemsQuery } from 'marketplace-ui-common/collections/queries/collectionItemsQuery';
import { appCollectionItemsResponseSchema } from 'marketplace-ui-client-types/marketplace-quality-customer-service-v1/schema';
export const GET_APP_COLLECTION_ITEMS = registerCollectionItemsQuery({
  offeringType: 'APP',
  fieldName: 'appCollectionItems',
  schema: appCollectionItemsResponseSchema
});